var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Assets",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assets",
    transform: "translate(-760.000000, -2641.000000)",
    fill: "#858199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/Notification",
    transform: "translate(760.000000, 2641.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,18 C14,19.1 13.1,20 12,20 C10.9,20 10,19.1 10,18 L14,18 Z M19,15 C19.6,15 20,15.4 20,16 C20,16.6 19.6,17 19,17 L5,17 C4.4,17 4,16.6 4,16 C4,15.4 4.4,15 5,15 L5.5,15 C6.2,14.3 7,13.3 7,12 L7,9 C7,6.2 9.2,4 12,4 C14.8,4 17,6.2 17,9 L17,12 C17,13.3 17.8,14.3 18.5,15 L19,15 Z",
    id: "Fill"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotification);
export default __webpack_public_path__ + "static/media/iconNotification.ab520e9c.svg";
export { ForwardRef as ReactComponent };